
import { HttpShipOBillList } from '@/service/boss/shipment'
import TableList from "@components/templates/tablelist";
import { mapState,mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Searchs: {
                show: true,
                labelWidth: 90,
            },
        };
    },
    methods: {
        ajaxRequest: HttpShipOBillList,
    },
    computed: {
        ...mapGetters('diction',['getNewProductList','getAllCurrency']),
        SearchsData() {
            return  [
                {
                    label: "项目",
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    options:this.getNewProductList,
                    show:true,
                    props:{
                        filterable:true,
                    }
                },
                {
                    label: "币种",
                    tag: 'vSelect',
                    key: 'EQ_currency',
                    show:true,
                    options:this.getAllCurrency,
                },
                {
                    label: "采购单号",
                    tag: 'vInput',
                    show:true,
                    key: 'CN_poNo',
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width:60,
                    formName:'sourceOrderId'
                },
                {
                    title: 'sourceOrderNo',
                    key: 'sourceOrderNo',
                },
                {
                    title: '项目',
                    key: 'lineId',
                    render: (h, { row }) => {
                        const id = row.lineId;
                        const product = this.getNewProductList.find((item) => {
                            return id == item.value
                        }) || {};
                        return product.label
                    },
                }, {
                    title: 'currency',
                    key: 'currency',
                }
            ];
        },
    },
};




